import { render } from "./Footer.vue?vue&type=template&id=a57b3978&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=a57b3978&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src39322066/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57b3978"]])

export default __exports__